import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";

@Component({
  selector: "app-pro-reject-case",
  templateUrl: "./reject-case.component.html",
})
export class RejectCaseComponent implements OnInit {
  rejectForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.rejectForm = new FormGroup({
      rejectReason: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(1000),
      ]),
    });
  }

  reject() {
    if (this.rejectForm.valid) {
      return this.modalCtrl.dismiss(
        this.rejectForm.value.rejectReason,
        "reject"
      );
    } else {
      this.presentErrorToast("Reject Reason is required.");
    }
  }

  async presentErrorToast(message: string) {
    this._snackBar.open(message, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
